import { gql } from '@urql/core'

export const queryMilestoneConfigurationById = gql`
  query ($milestoneConfigId: Int!) {
    milestone_config_by_pk(id: $milestoneConfigId) {
      id
      type
      process
      frequency
      task_months
      description
      workflow_type
      initial_responsible_type
      day
      month
      workflow_type
      active
    }
  }
`

export const updateMilestoneConfigById = gql`
  mutation ($id: Int!, $input: milestone_config_set_input!) {
    update_milestone_config(where: { id: { _eq: $id } }, _set: $input) {
      affected_rows
    }
  }
`

export const queryMilestoneConfigs = gql`
  query (
    $milestoneConfigCondition: milestone_config_bool_exp
    $offset: Int!
    $limit: Int!
    $orderBy: [milestone_config_order_by!]
  ) {
    milestone_config(where: $milestoneConfigCondition, offset: $offset, limit: $limit, order_by: $orderBy) {
      id
      type
      process
      frequency
      description
      initial_responsible_type
      day
      month
      workflow_type
      active
    }
    milestone_config_aggregate(where: $milestoneConfigCondition, order_by: $orderBy) {
      aggregate {
        count
      }
    }
  }
`

export const queryMilestoneConfigurationDescription = gql`
  query ($milestoneConfigCondition: milestone_config_bool_exp) {
    milestone_config(where: $milestoneConfigCondition) {
      id
      description
      type
      process
    }
  }
`
